import React from 'react';

import arrowIcon from '../../../images/ic_arrow_left.svg';
import arrowStyle from './ArrowLeft.style';
import Arrow from '../../Arrows/Arrow';

const ArrowLeft = props => <Arrow arrowIcon={arrowIcon} arrowStyle={arrowStyle} {...props} />;

export default ArrowLeft;
